import { FunctionComponent } from "react";
import { Tenant } from "../src/types";
import { Badge } from "@/components/shadcn/ui/badge";

const TenantKindBadge: FunctionComponent<{ kind: Tenant["kind"] }> = ({
  kind,
}) => {
  const label =
    kind === "production" ? "Business Account" : "Developer Account";
  // Keep on one line and allow truncation inside the sidebar width.
  return (
    <Badge
      variant="secondary"
      className="px-2 py-0 text-[11px] font-medium whitespace-nowrap max-w-full overflow-hidden"
    >
      <span className="truncate">{label}</span>
    </Badge>
  );
};

export default TenantKindBadge;
